import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {Box, merge} from '@primer/react'
import {useCallback, useState} from 'react'

import {LevelIndicatorLines} from './LevelIndicatorLines'

const outerContainerStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  height: '38px',
  minWidth: '1rem',
}

const innerContainerStyles: BetterSystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  color: 'fg.muted',
  width: '1rem',
}

const iconContainerStyles: BetterSystemStyleObject = {
  width: 16,
  height: 16,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export function HierarchyIndicator({
  initialIsExpanded = false,
  levels,
  hasChildren,
  onExpand,
}: {
  levels: boolean[]
  initialIsExpanded?: boolean
  hasChildren: boolean
  onExpand: (isExpanded: boolean) => void
}) {
  const [isExpanded, setIsExpanded] = useState(initialIsExpanded)
  const handleToggle = useCallback(() => {
    onExpand(!isExpanded) // sending in the new value
    setIsExpanded(!isExpanded)
  }, [isExpanded, onExpand])

  let icon = null
  if (hasChildren) {
    icon = isExpanded ? <ChevronDownIcon size={12} /> : <ChevronRightIcon size={12} />
  }

  return (
    <Box sx={outerContainerStyles}>
      <LevelIndicatorLines levels={levels} />
      <Box
        sx={merge<BetterSystemStyleObject>(innerContainerStyles, {
          cursor: icon ? 'pointer' : null,
          '&:hover': {backgroundColor: icon ? 'treeViewItem.chevron.hoverBg' : null},
        })}
        onClick={handleToggle}
      >
        <>
          <Box sx={iconContainerStyles}>{icon}</Box>
          <LevelIndicatorLines isExpanded={true} levels={isExpanded ? [false] : []} />
        </>
      </Box>
    </Box>
  )
}

try{ HierarchyIndicator.displayName ||= 'HierarchyIndicator' } catch {}